var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",staticClass:"session-moves-stats"},[_vm._v(" Correct moves: "+_vm._s(_vm.sessionMovesCorrect)+"/"+_vm._s(_vm.sessionMovesTotal)+" ("),_c('b',[_vm._v(_vm._s(_vm.sessionMovesCorrectPercentage)+"%")]),_vm._v(") ")])
}
var staticRenderFns = []

export { render, staticRenderFns }